import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@ngneat/transloco';
import { Injectable } from '@angular/core';
import { DEFAULT_CULTURE } from '@app-lib';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(langPath: string) {
    if (langPath == null) {
      langPath = DEFAULT_CULTURE;
    }
    //onsole.warn('NG.LOADER.WRN.00 ===>' + `./assets/i18n/${langPath}.json`);
    return this.http.get<Translation>(`./assets/i18n/${langPath}.json`);
  }
}
